module.exports = __webpack_public_path__ + "img/icon-similar-gray.b2baa1d0.svg";